module.exports = __webpack_public_path__ + "img/logo.bf16aa8d.png";